import { CustomFilter, CustomFilterOperator, ReportPropertyBase, ReportPropertyType } from "generated/openApi";
import { CustomFilterOperatorOption, customFilterOperatorOptions } from "./operators";

export const getOperatorOptions = (property: ReportPropertyBase | undefined) => {
  if (property?.selectList) {
    return customFilterOperatorOptions.filter((x) =>
      [
        CustomFilterOperator.Equal,
        CustomFilterOperator.NotEqual,
        CustomFilterOperator.IsNull,
        CustomFilterOperator.IsNotNull,
      ].includes(x.operator)
    );
  }

  const propertyType = property?.propertyType;
  switch (propertyType) {
    case ReportPropertyType.String:
      return customFilterOperatorOptions.filter((x) =>
        [
          CustomFilterOperator.Equal,
          CustomFilterOperator.NotEqual,
          CustomFilterOperator.Contains,
          CustomFilterOperator.BeginsWith,
          CustomFilterOperator.EndsWith,
          CustomFilterOperator.IsNull,
          CustomFilterOperator.IsNotNull,
        ].includes(x.operator)
      );
    case ReportPropertyType.Int:
      return customFilterOperatorOptions.filter((x) =>
        [
          CustomFilterOperator.Equal,
          CustomFilterOperator.NotEqual,
          CustomFilterOperator.GreaterThan,
          CustomFilterOperator.GreaterEqualThan,
          CustomFilterOperator.LessThan,
          CustomFilterOperator.LessEqualThan,
          CustomFilterOperator.IsNull,
          CustomFilterOperator.IsNotNull,
        ].includes(x.operator)
      );
    case ReportPropertyType.Decimal:
      return customFilterOperatorOptions.filter((x) =>
        [
          CustomFilterOperator.Equal,
          CustomFilterOperator.NotEqual,
          CustomFilterOperator.GreaterThan,
          CustomFilterOperator.GreaterEqualThan,
          CustomFilterOperator.LessThan,
          CustomFilterOperator.LessEqualThan,
          CustomFilterOperator.IsNull,
          CustomFilterOperator.IsNotNull,
        ].includes(x.operator)
      );
    case ReportPropertyType.Bool:
      return customFilterOperatorOptions.filter((x) => [CustomFilterOperator.Equal].includes(x.operator));
    case ReportPropertyType.NullableBool:
      return customFilterOperatorOptions.filter((x) =>
        [CustomFilterOperator.Equal, CustomFilterOperator.IsNull, CustomFilterOperator.IsNotNull].includes(x.operator)
      );
    case ReportPropertyType.Date:
      return customFilterOperatorOptions.filter((x) =>
        [
          CustomFilterOperator.Equal,
          CustomFilterOperator.NotEqual,
          CustomFilterOperator.GreaterThan,
          CustomFilterOperator.GreaterEqualThan,
          CustomFilterOperator.LessThan,
          CustomFilterOperator.LessEqualThan,
          CustomFilterOperator.IsNull,
          CustomFilterOperator.IsNotNull,
        ].includes(x.operator)
      );
    case ReportPropertyType.DateTimeOffset:
      return customFilterOperatorOptions.filter((x) =>
        [
          CustomFilterOperator.Equal,
          CustomFilterOperator.NotEqual,
          CustomFilterOperator.GreaterThan,
          CustomFilterOperator.GreaterEqualThan,
          CustomFilterOperator.LessThan,
          CustomFilterOperator.LessEqualThan,
          CustomFilterOperator.IsNull,
          CustomFilterOperator.IsNotNull,
        ].includes(x.operator)
      );
    case ReportPropertyType.TimeSpan:
      return customFilterOperatorOptions.filter((x) =>
        [
          CustomFilterOperator.Equal,
          CustomFilterOperator.NotEqual,
          CustomFilterOperator.GreaterThan,
          CustomFilterOperator.GreaterEqualThan,
          CustomFilterOperator.LessThan,
          CustomFilterOperator.LessEqualThan,
          CustomFilterOperator.IsNull,
          CustomFilterOperator.IsNotNull,
        ].includes(x.operator)
      );
    default:
      return [customFilterOperatorOptions.find((x) => x.operator === CustomFilterOperator.Equal)!];
  }
};

export const validateCustomFilter = (
  filter: CustomFilter,
  operatorOptions: CustomFilterOperatorOption[] | undefined
): string | undefined => {
  
  if (filter.property === undefined) return "Field is required";
  if (filter.operator === undefined) return "Operator is required";

  const operatorOption = operatorOptions?.find((option) => option.operator === filter.operator);

  // If the operator is not found in the dbtFilterOperatorOptions array, return false
  if (!operatorOption) return "Operator is not found";

  // If the field's data type is not found, return false
  if (filter.property?.propertyType === undefined) return "Type is not found";

  // Check if the operator's applicableFieldTypes include the field's data type
  if (!getOperatorOptions(filter.property)?.includes(operatorOption)) return "Operator is not valid for the Field type";
  //if (!operatorOption.applicablePropertyTypes.includes(propertyType)) return "Operator is not valid for the Field type";

  // TODO: if filter's values array is null or empty, return false, unless the operatorOption.filterValueType === "None"
  if ((!filter.values || filter.values.length === 0) && operatorOption.filterValueType !== "None")
    return "Value(s) required for the selected Operator";

  return undefined;
};
